window.i18n = {
  sidebar: {
    information: "Information",
    playerSearch: "Spielersuche",
    leaderboard: "Leaderboard",
    highlights: "Highlights",
    fullscreenIn: "Vollbild",
    fullscreenExit: "Vollbild",
    programme: "Programm",
    results: "Results",
    schedule: "Daily schedule",
    matchplayPlayers: "Player search",
    matchplayLeaderboard: "Leaderboard",
  },
  slider: {
    round: "Runde",
    information: "Information",
    playerSearch: "Spielersuche",
    leaderboard: "Leaderboard",
    highlights: "Highlights",
    location: "Position",
    programme: "Programm",
    today: "Heute",
    results: "Results",
    schedule: "Daily schedule",
    matchplayPlayers: "Player search",
    matchplayLeaderboard: "Scoring",
  },
  information: {
    "show-all-layers": "Alles anzeigen",
    groups: "Gruppen",
    hole: "Löcher",
  },
  leaderboard: {
    noDataAvailable: "Es liegen noch keine Scoring-Daten vor.",
  },
  leaderboardHeader: {
    pos: "Pos",
    name: "Name",
    par72: "Par 72",
    thru: "Thru",
    today: "Heute",
    total: "Total",
    favorite: "Fav",
  },
  autocomplete: {
    player: "Name",
    tee: "Tee",
    thru: "Thru",
    group: "Gruppe",
    placeholder: "Spieler suchen",
    noDataAvailable: "Es liegt noch keine Starterliste vor.",
  },
  popupContent: {
    group: "Gruppe",
    tee: "Tee",
    hole: "Loch",
    players: "Name",
    pos: "Pos",
    par: "Par",
    thru: "Thru",
    today: "Heute",
  },
  popupContentMatchPlay: {
    round: "runde",
    match: "match",
    hole: "loch",
  },
  playersOnThisArea: "Players currently on this area:",
  backToHome: {
    title: "Karte zentrieren",
  },
  zoomIn: {
    title: "Reinzoomen",
  },
  zoomOut: {
    title: "Rauszoomen",
  },
  location: {
    denied: {
      first: "Du hast Dich entschieden, Deine Location nicht freizugeben.",
      second:
        "Zum Nutzen des vollständigen Funktionsumfangs gib bitte wie folgt Deine Location frei.",
    },
    unavailable: "Das Netzwerk ist derzeit nicht erreichbar.",
    timeout: "Netzwerk timeout",
    error: "Geolocation-Fehler.",
    "on-off": "GPS Location An/Aus:",
    maxBound: {
      title: "Position",
      text: "Du befindest Dich derzeit außerhalb des Veranstaltungsortes. Wir zeigen Deine Position an, sobald Du Dich dem Veranstaltungsort näherst.",
    },
    android: {
      swipe: "Vom oberen Rand des Bildschirms nach unten wischen.",
      touch: "Drücke und halte Location",
      location: "Wenn Location nicht sichtbar ist",
      edit: "Klicke Bearbeiten ",
      settings: "oder Einstellungen",
      drag: "Ziehe Location",
      quick: "in Deine Quick Settings",
    },
    apple: {
      settings: "Gehe zu Einstellungen",
      privacy: "Datenschutz",
      services: "Ortungsdienste.",
      location: "Stelle sicher, dass Ortungsdienste angeschaltet sind.",
    },
  },
  info: {
    message: "3 Loch Scoring - derzeit keine Livedaten der Spieler verfügbar.",
  },
  tennisEventTypeName: {
    MS: "Einzel",
    MD: "Doppel",
    QS: "Qualifying",
    QD: "Qualifying Doppel",
    LS: "Damen Single",
    LD: "Damen Doppel",
    RS: "Damen Qualifying",
    RD: "Damen Qualifying Doppel",
  },
};
